import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";

import IApp from "../IApp";

import SystemConfig, {CONFIG_PARAMS} from "../../system/SystemConfig";

import * as madnes from "./madnes";
import {mobileAndTabletCheck} from "../../device/device";
import {madnes_render} from "./madnes_render";
import MadnesLoader from "./MadnesLoader";
import InitResult from "../../connect/result/InitResult";
import {madnes_adapter} from "./madnes_variables";
import events from "../../events/EventsObservable";
import {EVENTS} from "../../events/baseEvents";
import IScreenData from "../../ui/screen/IScreenData";
import IDOM from "../../ui/IDOM";
import Settings from "../../settings/Settings";
import {getScale} from "../../ui/screen/AbstractUIScreen";

export let main_phaser:Phaser.Game;
export let wintable_phaser:Phaser.Game;

@injectable()
class MadnesApp implements IApp {

    private config: SystemConfig;
    private loader: MadnesLoader;
    private dom: IDOM;
    private gameset: any;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.EngineLoader) loader: MadnesLoader,
        @inject(SERVICE_IDENTIFIER.DOM) dom: IDOM
    ) {
        this.config = config;
        this.loader = loader;
        this.gameset = config.gameset;
        this.dom = dom;

        events.subscribe(EVENTS.PREINIT_SUCCESS, (eventName, settings) => this.onPreInitSuccess(settings));
        events.subscribe(EVENTS.INIT_SUCCESS, (eventName, initResult) => this.onInitSuccess(initResult))
    }

    init() {

        // @ts-ignore
        window.PhaserGlobal = {
            hideBanner: true
        };

        return new Promise<void>(res => {

            let renderer = Phaser.AUTO;
            if(mobileAndTabletCheck()) {
                renderer = Phaser.CANVAS;
            }

            let cfgRender = this.config.get(CONFIG_PARAMS.RENDER);

            if(cfgRender) {
                renderer = Phaser[cfgRender]
            }

            let phaserConfig = {
                width: this.gameset.stageWidth,
                height: this.gameset.stageHeight,
                renderer: renderer,
                parent: this.dom.getGameWrapper(),
                state: {
                    preload: () => { this.loader.phaserPreload(); res(); },
                    create:  this.loader.phaserCreate.bind(this.loader),
                    // update: update,
                    render: madnes_render
                },
                transparent: false,
                enableDebug: false,
                antialias: true,
            };

            main_phaser = new Phaser.Game(phaserConfig);

            // window.main_phaser = main_phaser;
            // main_phaser.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
            // main_phaser.scale.pageAlignHorizontally = true;
            // main_phaser.scale.pageAlignVertically = true;

            if(this.config.get(CONFIG_PARAMS.SEPARATED_INFOPAGES)) {
                wintable_phaser = new Phaser.Game({
                    width: this.gameset.stageWidth,
                    height: this.gameset.stageHeight,
                    renderer: renderer,
                    parent: this.dom.getWintableWrapper(),
                    transparent: false,
                    enableDebug: false
                });
                // wintable_phaser.paused = true;
                // wintable_phaser.lockRender = true;
            }

            madnes.initApp();
            madnes_adapter.initGame(this.gameset);

        });
    }

    onResize(data: IScreenData) {
    // onResize({canvasWidth, canvasHeight}: {canvasWidth: number, canvasHeight: number}) {

        if(!main_phaser || !main_phaser.scale) return;
        if(this.config.get(CONFIG_PARAMS.SEPARATED_INFOPAGES) && (!wintable_phaser || !wintable_phaser.scale)) return;

        //main_phaser.renderer.resize(1280 * containerScale, 720 * containerScale);
        //main_phaser.scale && main_phaser.scale.setGameSize(1280 * containerScale, 720 * containerScale);

        // let s = $("#container").width() / this.gameset.stageWidth; // 0.5625

        // console.log(canvasWidth, canvasHeight);

        this._resizeCanvas(main_phaser, data);

        if(this.config.get(CONFIG_PARAMS.SEPARATED_INFOPAGES)) {
            this._resizeCanvas(wintable_phaser, data, true);
        }
    }

    _resizeCanvas(phaser: Phaser.Game, data: IScreenData, info: boolean = false) {
        // different info canvas size when VLT2UI
        if (
            info &&
            this.config.get(CONFIG_PARAMS.EXHIBITION) === "2" &&
            this.config.get(CONFIG_PARAMS.DISPLAYS) === 2
        ) {
            let widthOrig = this.gameset.stageWidth;
            let heightOrig = this.gameset.stageHeight;
            let scale = getScale(
                data.containerWidthScaled,
                data.containerHeightScaled,
                widthOrig,
                heightOrig
            );
            data.canvasWidthScaled = widthOrig * scale;
            data.canvasHeightScaled = heightOrig * scale;
        }

        phaser.scale.width =
            phaser.scale.minWidth =
                phaser.scale.maxWidth = data.canvasWidthScaled;

        phaser.scale.height =
            phaser.scale.minHeight =
                phaser.scale.maxHeight = data.canvasHeightScaled;

        // @ts-ignore
        phaser.scale.reflowCanvas();
    }

    private onPreInitSuccess(settings: Settings) {
        madnes.onServerPreInit(settings);
    }

    private onInitSuccess(initResult: InitResult) {
        if(this.config.get(CONFIG_PARAMS.SEPARATED_INFOPAGES)) {
            wintable_phaser.cache = main_phaser.cache;
        }
        madnes.onServerInit(initResult);
    }

    loadComplete() {}
}

export default MadnesApp;